import ConfigService from './ConfigService'

export default new (class ProductService {
  get products() {
    const { articles, bundles } = ConfigService.get('shop.products')
    return [...articles.map(a => ({ ...a, type: 'article' })), ...bundles.map(b => ({ ...b, type: 'bundle' }))]
  }

  findProductById(productId) {
    return this.products.find(p => p.id === productId)
  }

  getProductProperties(productId) {
    const product = this.findProductById(productId)
    return (product && product.properties) || {}
  }

  getProductProperty(productId, propertyName) {
    const productProperties = this.getProductProperties(productId)
    return productProperties && productProperties[propertyName]
  }
})()
